import { localeString } from './storage.js'

const VueAxiosPlugin = {}
let AddOptionalHeader
export default VueAxiosPlugin.install = (app, { axios }) => {
  const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

  axios.defaults.headers.common = {
    'X-CSRF-Token': csrfToken,
    'Content-Type': 'application/json',
  }
  AddOptionalHeader = axios.interceptors.request.use(function (config) {
    config.headers['X-Locale'] = localeString()
    return config
  })

  app.axios = axios
  Object.defineProperties(app.config.globalProperties, {
    axios: {
      get () {
        return axios
      }
    }
  })
}
export { AddOptionalHeader }
